import BaseService from './BaseService';
import AvailabilityApiAgency from '@/api/AvailabilityApiAgency';
import UnavailabilityApiAgency from '@/api/UnavailabilityApiAgency';
import UnavailabilityApiTempWorker from '@/api/UnavailabilityApiTempWorker';
import AvailabilityApiTempWorker from '@/api/AvailabilityApiTempWorker';
import SpecificAvailabilityApiTempWorker from '@/api/SpecificAvailabilityApiTempWorker';

class AvailabilityService extends BaseService {

	async getAsync (...args: Parameters<typeof AvailabilityApiAgency.get>) {
		if (this.self.isAgency()) {
			const { data } = await AvailabilityApiAgency.get(...args);
			return data;
		}
	}

	async getTempworkerAsync (...args: Parameters<typeof AvailabilityApiTempWorker.get>) {
		const { data } = await AvailabilityApiTempWorker.get(...args);
		return data;

	}

	async addAsync (...args: Parameters<typeof AvailabilityApiTempWorker.add>) {
		const { data } = await AvailabilityApiTempWorker.add(...args);
		return data;
	}

	async updateIsAvailableAsync (...args: Parameters<typeof AvailabilityApiTempWorker.updateIsAvailable>) {
		const { data } = await AvailabilityApiTempWorker.updateIsAvailable(...args);
		return data;
	}

	async updateScheduleAsync (...args: Parameters<typeof AvailabilityApiTempWorker.updateSchedule>) {
		const { data } = await AvailabilityApiTempWorker.updateSchedule(...args);
		return data;
	}

	async addSpecificAsync (...args: Parameters<typeof SpecificAvailabilityApiTempWorker.add>) {
		const { data } = await SpecificAvailabilityApiTempWorker.add(...args);
		return data;
	}

	async updateSpecificAsync (...args: Parameters<typeof SpecificAvailabilityApiTempWorker.update>) {
		const { data } = await SpecificAvailabilityApiTempWorker.update(...args);
		return data;
	}

	async deleteSpecificAsync (...args: Parameters<typeof SpecificAvailabilityApiTempWorker.delete>) {
		const { data } = await SpecificAvailabilityApiTempWorker.delete(...args);
		return data;
	}

	async addUnavailabilityAsync (...args: Parameters<typeof UnavailabilityApiTempWorker.add>) {
		const { data } = await UnavailabilityApiTempWorker.add(...args);
		return data;
	}

	async deleteUnavailabilityAsync (...args: Parameters<typeof UnavailabilityApiTempWorker.delete>) {
		const { data } = await UnavailabilityApiTempWorker.delete(...args);
		return data;
	}

	async listUnavailabilitiesByUserIdAsync (...args: Parameters<typeof UnavailabilityApiAgency.listByUserId>) {
		if (this.self.isAgency()) {
			const { data } = await UnavailabilityApiAgency.listByUserId(...args);
			return data;
		}
		return [];
	}
}

export default function useAvailabilityService () {
	return new AvailabilityService();
}
